import { render, staticRenderFns } from "./CaptiveFormsListItemActions.vue?vue&type=template&id=378672a2&scoped=true"
import script from "./CaptiveFormsListItemActions.vue?vue&type=script&lang=js"
export * from "./CaptiveFormsListItemActions.vue?vue&type=script&lang=js"
import style0 from "./CaptiveFormsListItemActions.vue?vue&type=style&index=0&id=378672a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378672a2",
  null
  
)

export default component.exports